/* istanbul ignore file */
export * from './shared-sky-components.module';
export { SkyHeaderComponent } from './sky-header/sky-header.component';
export { SkyBoxDetailsComponent } from './sky-box-details/sky-box-details.component';
